import { useEffect } from 'react';
import { MenuConfig } from "../../../../../../../../components/Menu/MenuConfig";
import { WorkSpaceUserName } from "../../../../../../../../model/ItemModel";
import { IShowInfo } from "../../../../../../DocumentDetail"
import ViwerInfo from "../../../../components/ViwerInfo/ViwerInfo";
import DocumentDetailViwer from "../DocumentDetailViwer/DocumentDetailViwer";
import { Box } from '@mui/material';
import { ParameterViwer } from '../../../../../../../WorkSpaceItem/Viwer/ParameterViwer';
import { ModalStyled } from '../../../../../../../../components/StyledModal/StyledModal';
import ChoicerViwer, { ViewerOptions } from '../../../../../../../WorkSpaceItem/Viwer/ChoicerViwer';
import { DownloadViwer, GetOneItem } from '../../../../../../../../services/Item/ItemServicesGet';

interface IDocumentDetailViwerSwitch {
    showViwerInfo: IShowInfo;
    workItem: WorkSpaceUserName;
    setShowViwerInfo: (set: IShowInfo) => void;
    isSidebarCollapsed: boolean;
    setSnackBarMessage: (set: string) => void;
    itemName: string;
    itemExtension: string;
    fullScreenSetted: boolean;
    parameter:ParameterViwer;
    isNotebookWidth: boolean;
    setSnackBarMessageIsSuccess: (set: boolean) => void;
}

export default function DocumentDetailViwerSwitch({
    setShowViwerInfo,
    showViwerInfo,
    workItem,
    isSidebarCollapsed,
    setSnackBarMessage,
    itemName,
    itemExtension,
    fullScreenSetted,
    parameter,
    isNotebookWidth,
    setSnackBarMessageIsSuccess
 }: IDocumentDetailViwerSwitch) {

    return (
        <ChoicerViwer
            idItem={workItem?.id!}
            download={DownloadViwer}
            getItem={GetOneItem}
            positionAbsolute={true}
            title={``}
            setShowViwerInfo={setShowViwerInfo}
            isDetailPage={true}
            isAcept={false}
            fullScreenSetted={fullScreenSetted}
            isSidebarCollapsed={isSidebarCollapsed}
            isSharedFilePage={false}
        />
    )
}